<div style="height: 100vh; clear: both; padding: 0;" class="section md-hero ">
    <ng-container #container></ng-container>
</div>
